export default __webpack_public_path__ + "static/media/dress11.e9fb6e1c.jpeg";